export default "__VITE_ASSET__abe201b8__"